export async function createClient(clientType,firstName, lastName, email, owner_nick, nicks = []) {
  try {
    const response = await fetch('/api/clients', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        client_type: clientType,
        first_name: firstName,
        last_name: lastName,
        email: email,
        owner_nick: owner_nick,
        nicks: nicks 
      })
    });

    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }

    const result = await response.json();
    // Expecting: { clientId: 'abc123', clientCode: 'XYZ456' }

    if (result.client_id && result.client_code) {
      return {
        success: true,
        clientId: result.client_id,
        clientCode: result.client_code
      };
    }

    return { success: false };
  } catch (err) {
    console.error('[createClient] Failed:', err);
    return { success: false };
  }
}

export async function loadClient() {
  try {
    const response = await fetch('/api/clients');
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const client = await response.json();
    return client;
  } catch (err) {
    console.error('[loadClient] Failed:', err);
    return null;
  }
}

export async function loadClientNicks() {
  try {
    const response = await fetch('/api/clients/nicks');
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const nicks = await response.json();
    return nicks;
  } catch (err) {
    console.error('[loadClientNicks] Failed:', err);
    return [];
  }
}

export async function createClientNicks(newNicks) {
  try {
    const response = await fetch('/api/clients/nicks/batch-create', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newNicks),
    });

    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const nicks = await response.json();
    return nicks;
  } catch (err) {
    console.error('[updateClientNicks] Failed:', err);
    return [];
  }
}

export async function updatelientNicks(pendingNicks) {
  try {
    const response = await fetch('/api/clients/nicks/batch-update', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({nicks: pendingNicks}),
    });

    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const nicks = await response.json();
    return nicks;
  } catch (err) {
    console.error('[updateClientNicks] Failed:', err);
    return [];
  }
}

export async function sendFeedback(rating, type, details) {
  console.log('[FeedbackCreatePanel] Sending feedback:', { rating, type, details });
  try {
    const response = await fetch('/api/clients/send-feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ rating, type, details })
    });
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
  } catch (err) {
    console.error('[FeedbackCreatePanel] Failed to send feedback:', err);
  }
}

export async function getFeatureFlagsFromServer() {
  try {
    const response = await fetch('/api/clients/feature-flags');
    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }
    const resp = await response.json();
    return resp;
  } catch (err) {
    console.error('[getFeatureFlagsFromServer] Failed:', err);
    return null;
  }
}